import { observer } from 'mobx-react'
import React from 'react'
import Markdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'
import cn from 'classnames'

import { getDomSanitizedValue } from '@flowwai-frontend/shared/utils/common'

import './index.css'
import {
   getFormattedLineBreakMarkdownContent,
   getFormattedVariableMarkdownContent
} from '../../utils/MarkdownContentUtils'

interface Props {
   content: string
   className?: string
   applyLineBreaks?: boolean
}

const MarkdownContent = (props: Props): React.ReactElement => {
   const { content, className, applyLineBreaks = false } = props

   const formattedMarkdown = applyLineBreaks
      ? getFormattedLineBreakMarkdownContent(content)
      : getFormattedVariableMarkdownContent(content)
   const sanitizedMarkdown = getDomSanitizedValue(formattedMarkdown)

   const remarkPlugins = applyLineBreaks
      ? [remarkGfm, remarkBreaks]
      : [remarkGfm]

   return (
      <Markdown
         components={{
            a: ({ href, children, ...props }) => (
               <a
                  href={href}
                  target='_blank'
                  rel='noopener noreferrer'
                  {...props}
               >
                  {children}
               </a>
            )
         }}
         remarkPlugins={remarkPlugins}
         className={cn('markdown-content', className)}
      >
         {sanitizedMarkdown}
      </Markdown>
   )
}

export default observer(MarkdownContent)
